import Swal from "sweetalert2";
export const toastError = (msg, err) =>
  toast.fire({ icon: "error", title: msg });

export const toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  width: 360,
  timer: 3000,
  showClass: {
    popup: "animate__animated animate__fadeInDown",
  },
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
